import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { SoSvgIconUI } from 'so-components-kit';
import { SharedModule } from '@shared/shared.module';
import { GetWsSyncStateUseCase } from '../../domain/use-cases/get-ws-sync-state.use-case';
import { WsSyncLogsModalComponent } from '../ws-sync-logs-modal/ws-sync-logs-modal.component';

@Component({
  selector: 'app-ws-sync-overlay',
  standalone: true,
  imports: [CommonModule, SharedModule, SoSvgIconUI],
  templateUrl: './ws-sync-overlay.component.html',
  styleUrl: './ws-sync-overlay.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WsSyncOverlayComponent {
  private readonly getWsSyncStateUseCase = inject(GetWsSyncStateUseCase);
  private readonly matDialog = inject(MatDialog);

  public readonly idMarca = input<string | null>(null);
  public readonly idSubmarca = input<string | null>(null);

  public readonly pending = computed(() =>
    this.getWsSyncStateUseCase.pending(this.idMarca() ?? '', this.idSubmarca() ?? '')()
  );

  public readonly active = computed(() =>
    this.getWsSyncStateUseCase.execute(this.idMarca() ?? '', this.idSubmarca() ?? '')()
  );

  public readonly visible = computed(() => this.pending() || this.active());

  openLogs(): void {
    const idMarca = this.idMarca();
    const idSubmarca = this.idSubmarca();
    if (!idMarca || !idSubmarca) return;
    this.matDialog.open(WsSyncLogsModalComponent, {
      data: { idMarca, idSubmarca },
      width: '800px',
      maxHeight: '85vh',
      panelClass: 'ws-sync-logs-modal-panel',
    });
  }
}
